import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import { products } from '../../mocks/products';

const ProductsPage = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Set page title and meta tags
    document.title = '2. El Bilgisayar ve Laptop Satışı - Uygun Fiyatlı İkinci El Ürünler | Es Donanım Bilgisayar';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Ankara\'da uygun fiyatlı 2. el bilgisayar, ikinci el laptop, oyuncu bilgisayarı ve masaüstü bilgisayar satışı. Garantili, test edilmiş ürünler. Es Donanım Bilgisayar güvencesiyle.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '2. el bilgisayar, ikinci el laptop, 2. el laptop satışı, oyuncu bilgisayarı, masaüstü bilgisayar, uygun fiyatlı bilgisayar, garantili 2. el bilgisayar, ikinci el bilgisayar ankara');
    }
    
    // Set canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', `${siteUrl}/urunler`);
    
    // Add Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": products.slice(0, 10).map((product, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Product",
          "name": product.name,
          "description": product.description,
          "brand": {
            "@type": "Brand",
            "name": product.brand
          },
          "offers": {
            "@type": "Offer",
            "price": product.price,
            "priceCurrency": "TRY",
            "availability": "https://schema.org/InStock",
            "seller": {
              "@type": "Organization",
              "name": "Es Donanım Bilgisayar"
            }
          },
          "itemCondition": "https://schema.org/UsedCondition"
        }
      }))
    });
    document.head.appendChild(schemaScript);
    
    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('newest');

  const categories = [
    { id: 'all', label: 'Tümü', icon: 'ri-apps-line' },
    { id: 'laptop', label: 'Laptop', icon: 'ri-macbook-line' },
    { id: 'desktop', label: 'Masaüstü', icon: 'ri-computer-line' },
    { id: 'gaming', label: 'Oyuncu PC', icon: 'ri-gamepad-line' },
    { id: 'monitor', label: 'Monitör', icon: 'ri-tv-line' },
  ];

  const getFilteredProducts = () => {
    let filtered = selectedCategory === 'all' 
      ? products 
      : products.filter(p => p.category === selectedCategory);

    if (sortBy === 'price-asc') {
      filtered = [...filtered].sort((a, b) => a.price - b.price);
    } else if (sortBy === 'price-desc') {
      filtered = [...filtered].sort((a, b) => b.price - a.price);
    }

    return filtered;
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pb-16 lg:pb-0">
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary via-primary-light to-primary">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 font-heading">
              2. El Bilgisayar ve Laptop
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto">
              Sıfır ayarında ikinci el bilgisayar, laptop ve oyuncu bilgisayarı seçenekleri. Garantili ve uygun fiyatlı ürünler.
            </p>
          </div>
        </section>

        {/* Filter Bar */}
        <section className="sticky top-20 z-30 bg-white border-b border-neutral-200 shadow-sm">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-6">
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between space-y-4 lg:space-y-0">
              {/* Categories */}
              <div className="flex items-center space-x-3 overflow-x-auto w-full lg:w-auto">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    className={`flex items-center space-x-2 px-5 py-2.5 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
                      selectedCategory === category.id
                        ? 'bg-secondary text-white'
                        : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'
                    }`}
                  >
                    <i className={`${category.icon} text-base`}></i>
                    <span>{category.label}</span>
                  </button>
                ))}
              </div>

              {/* Sort */}
              <div className="flex items-center space-x-3">
                <span className="text-sm text-neutral-600 whitespace-nowrap">Sırala:</span>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="px-4 py-2.5 bg-neutral-100 text-neutral-700 rounded-lg font-medium text-sm border-none outline-none cursor-pointer"
                >
                  <option value="newest">Yeni Eklenenler</option>
                  <option value="price-asc">Fiyat Artan</option>
                  <option value="price-desc">Fiyat Azalan</option>
                </select>
              </div>
            </div>
          </div>
        </section>

        {/* Products Grid */}
        <section className="py-24 bg-neutral-50">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {getFilteredProducts().map((product) => (
                <div
                  key={product.id}
                  className="group bg-white rounded-xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-2"
                  data-product-shop
                >
                  {/* Image */}
                  <div className="relative h-64 overflow-hidden bg-neutral-100">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    {/* Status Badge */}
                    <div className="absolute top-4 left-4">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${
                          product.status === 'new'
                            ? 'bg-secondary text-white'
                            : product.status === 'featured'
                            ? 'bg-accent text-white'
                            : 'bg-neutral-800 text-white'
                        }`}
                      >
                        {product.condition}
                      </span>
                    </div>
                    {/* Brand Badge */}
                    <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-1 rounded-lg">
                      <span className="text-xs font-semibold text-primary">{product.brand}</span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-primary mb-4 line-clamp-2">{product.name}</h3>

                    {/* Specs */}
                    <div className="space-y-2 mb-6">
                      {product.processor && (
                        <div className="flex items-center space-x-2 text-sm text-neutral-600">
                          <i className="ri-cpu-line text-accent"></i>
                          <span>{product.processor}</span>
                        </div>
                      )}
                      {product.ram && (
                        <div className="flex items-center space-x-2 text-sm text-neutral-600">
                          <i className="ri-database-2-line text-accent"></i>
                          <span>{product.ram}</span>
                        </div>
                      )}
                      {product.storage && (
                        <div className="flex items-center space-x-2 text-sm text-neutral-600">
                          <i className="ri-hard-drive-2-line text-accent"></i>
                          <span>{product.storage}</span>
                        </div>
                      )}
                      {product.gpu && (
                        <div className="flex items-center space-x-2 text-sm text-neutral-600">
                          <i className="ri-gamepad-line text-accent"></i>
                          <span>{product.gpu}</span>
                        </div>
                      )}
                      {product.specs && (
                        <div className="flex items-center space-x-2 text-sm text-neutral-600">
                          <i className="ri-settings-3-line text-accent"></i>
                          <span>{product.specs}</span>
                        </div>
                      )}
                    </div>

                    {/* Rating */}
                    <div className="flex items-center space-x-1 mb-4">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                      ))}
                      <span className="text-sm text-neutral-600 ml-2">({product.rating}.0)</span>
                    </div>

                    {/* Price */}
                    <div className="flex items-baseline space-x-2 mb-6">
                      {product.oldPrice && (
                        <span className="text-neutral-400 line-through text-sm">{product.oldPrice.toLocaleString('tr-TR')} ₺</span>
                      )}
                      <span className="text-2xl font-bold text-secondary">{product.price.toLocaleString('tr-TR')} ₺</span>
                    </div>

                    {/* Buttons */}
                    <div className="grid grid-cols-2 gap-3">
                      <Link
                        to={`/urunler/${product.slug}`}
                        className="flex items-center justify-center px-4 py-3 border-2 border-primary text-primary rounded-lg font-semibold text-sm hover:bg-primary hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                      >
                        Detayları Gör
                      </Link>
                      <a
                        href="https://wa.me/905XXXXXXXXX"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center space-x-2 px-4 py-3 bg-whatsapp text-white rounded-lg font-semibold text-sm hover:bg-whatsapp/90 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-whatsapp-line"></i>
                        <span>Sor</span>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-white">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
            <div className="bg-gradient-to-br from-primary via-primary-light to-primary rounded-3xl p-12 lg:p-16 text-center">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 font-heading">
                Aradığınız Ürünü Bulamadınız mı?
              </h2>
              <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto">
                İhtiyacınıza özel 2. el bilgisayar ve laptop seçenekleri için bizimle iletişime geçin
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                <a
                  href="tel:+905XXXXXXXXX"
                  className="flex items-center justify-center space-x-3 px-8 py-4 bg-secondary hover:bg-secondary-dark text-white rounded-lg font-semibold text-base shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line text-xl"></i>
                  <span>Hemen Ara</span>
                </a>
                <a
                  href="https://wa.me/905XXXXXXXXX"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center space-x-3 px-8 py-4 bg-whatsapp hover:bg-whatsapp/90 text-white rounded-lg font-semibold text-base shadow-lg hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  <span>WhatsApp ile İletişim</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default ProductsPage;